import { AsyncStorageKeys } from "../../Types";
import { globalAny } from "../../utils/Utils";
import backIcon from "../../assets/TopNavBarIcon/icon_nav_back.svg";
import TopAppbar from "../../components/TopAppBar";
import { useEffect, useState } from "react";
import { useNavigation } from "@react-navigation/native";
import parse from "html-react-parser";
import { Main, Container, Content, Text } from "./styled";
import useGenericContentStore from "../../store/genericContent.store";

const PrivacyPolicyScreen = () => {
	const navigation = useNavigation<any>();
	const [privacyPolicyText, setPrivacyPolicyText] = useState("");
	const { isNarrow } = useGenericContentStore((state) => ({ isNarrow: state.isNarrow }));

	/**
	 * Handles the back navigation action.
	 * If the navigation stack allows going back, it navigates to the previous screen.
	 * Otherwise, it redirects the user to the home page ("/").
	 */
	const onBackPress = () => {
		if (navigation.canGoBack()) navigation.goBack();
		else window.location.assign("/");
	};

	/**
	 * Loads cached legal data on component mount.
	 * Filters the legal contents for type 2 (Privacy Policy)
	 * and sets the HTML content to the state for rendering.
	 */
	useEffect(() => {
		const resultLegal = JSON.parse(localStorage.getItem(AsyncStorageKeys.cacheLegalDataCreate) ?? "{}");
		if (resultLegal) {
			let [data] = resultLegal?.legalContents?.filter((val: any) => val?.type === 2) ?? [];
			setPrivacyPolicyText(data?.htmlContent);
		}
	}, []);

	return (
		// @ts-ignore
		<Main>
			<TopAppbar
				leftIconWidth={92}
				leftTitleIcon={backIcon}
				screenTitle={globalAny.language.privacy_policy}
				onPressLeftTitleIcon={onBackPress}
				isSingleLogo
				isNarrow={isNarrow}
			/>
			{/* @ts-ignore */}
			<Container narrow={isNarrow}>
				{/* @ts-ignore */}
				<Content>
					{/* @ts-ignore */}
					<Text narrow={isNarrow}>{parse(privacyPolicyText.replace(/<a[^>]*>(.*?)/gi, "").replace("</a>", ""))}</Text>
				</Content>
			</Container>
		</Main>
	);
};

export default PrivacyPolicyScreen;
